import React from 'react';
import { Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Texto fijo en pantalla: requisitos mínimos del Excel de sensores y actuador (sin depender de PDFs).
 */
export const ArchivosSensoresHint: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Alert severity="info" sx={{ py: 1.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        {t('ensayos.archivos.hintTitle', 'Formato de los archivos de datos')}
      </Typography>
      <Typography variant="body2" component="div">
        <strong>{t('ensayos.archivos.actuadorTitle', 'Actuador (.xlsx)')}</strong>
        <ul style={{ marginTop: 6, marginBottom: 10 }}>
          <li>{t('ensayos.archivos.actuadorRowA', 'Columna A: timestamp (s)')}</li>
          <li>{t('ensayos.archivos.actuadorRowB', 'Columna B: fuerza (kN)')}</li>
          <li>{t('ensayos.archivos.actuadorRowF', 'Columna F: desplazamiento (mm)')}</li>
        </ul>
        <strong>{t('ensayos.archivos.sensoresTitle', 'Sensores Catman (.xlsx)')}</strong>
        <ul style={{ marginTop: 6, marginBottom: 10 }}>
          <li>{t('ensayos.archivos.sensoresTimestamp', 'Columna A: timestamp (s)')}</li>
          <li>
            {t(
              'ensayos.archivos.sensoresHeaders',
              'Nombres de canal en fila 2 y unidades en fila 3; los datos empiezan en la fila 50'
            )}
          </li>
          <li>
            {t(
              'ensayos.archivos.sensoresRaw',
              'RAW: canales tipo MX... (LVDT) y FS... (fibra óptica)'
            )}
          </li>
          <li>
            {t(
              'ensayos.archivos.sensoresFos',
              'Long-gauge FOS: usar sufijos temp/strain (ej. ...LGS2TFtemp / ...LGS2TFstrain)'
            )}
          </li>
          <li>{t('ensayos.archivos.sensoresProcess', 'Tras subir, pulsa «Procesar archivo»')}</li>
        </ul>
      </Typography>
    </Alert>
  );
};
